export const AiDashboardSx = {
  titleSx: {
    fontFamily: 'Inter',
    fontWeight: '600',
    fontSize: 'var(--font-size-30)',
    lineHeight: 'var(--line-height-38)',
    color: 'var(--color-primary)'
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  card: (isNoSpace = null) => ({
    gap: '16px',
    backgroundColor: 'var(--color-white)',
    boxShadow: '0px 0px 12px 2px rgba(0,0,0,0.06)',
    padding: isNoSpace ? '0px' : '24px',
    borderRadius: '8px',
    height: '100%',
    maxHeight: '100%'
  }),
  mainContainer: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, // left twice width
    //gridTemplateRows: { xs: 'auto auto auto', md: '1fr 1fr' },
    gap: '8px',
    marginTop: '1rem',
    gridAutoRows: 'auto',
    alignItems: 'start'
  },
  aiVisibilityScoreSx: {
    fontFamily: 'Inter',
    fontWeight: '500',
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-mid)'
  },
  scoreTitleBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '16px'
  },
  visibilityScoreModelsSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-text-placeholder)'
  },
  modalMainBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: '12px',
    paddingBottom: '12px'
  },
  modalNameBox: { display: 'flex', flexDirection: 'column', gap: '6px' },
  modalRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  modalNameSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-navy)'
  },
  statusChip: {
    paddingRight: '4px',
    paddingLeft: '4px',
    borderRadius: '16px'
  },
  statusChipText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: 'var(--line-height-18)',
    textAlign: 'center'
  },
  modalValueBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  modalValueText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-muted)'
  },
  modalLogo: {
    width: '20px',
    height: '20px'
  },
  yourMainCompetitors: {
    fontWeight: 500,
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-mid)'
  },
  topicVisibility: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-mid)'
  },
  skeletonModalMainBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  tableHead: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-text-placeholder)'
  },
  headBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '16px'
  },
  notMentioned: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'right',
    color: 'var(--color-text-tertiary)'
  },
  siteProgressLoadingText: {
    fontFamily: 'Inter',
    fontSize: { xs: '14px', sm: '16px' },
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'rgba(17, 20, 45, 0.52)',
    ml: 1
  },
  siteProgressLoadingSubBox: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  languageIconSx: {
    fontSize: 20,
    color: '#000000ad'
  },
  noDataFoundBox: {
    height: '300px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center'
  },
  noDataFoundText: {
    fontWeight: 500,
    fontSize: 'var(--font-size-18)',
    color: 'var(--color-text-secondary)',
    lineHeight: 'var(--line-height-22)'
  },
  mainBoxSx: {
    display: 'block',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'var(--color-bg-grey)',
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    marginBottom: '1rem'
  },
  comingSoonBoxSx: {
    height: '7px'
  },
  aiScoreChipTooltipLink: {
    fontWeight: 700,
    textDecoration: 'underline',
    textDecorationThickness: '1.2px',
    cursor: 'pointer',
    textUnderlineOffset: '4px'
  }
};

export const ImproveAiVisibilitySx = {
  headerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px 24px 16px 24px'
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-mid)'
  },
  paginationBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  pageText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  iconBtn: {
    p: 0.5
  },
  icon: (isBlue) => ({
    fontSize: 16,
    color: isBlue ? 'var(--color-primary)' : 'var(--color-text-placeholder)'
  }),
  subText: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-mid)',
    marginTop: '6px'
  },
  itemBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 24px 12px 24px'
  },
  itemTitle: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-muted)'
  },
  itemDesc: {
    fontWeight: 400,
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginTop: '6px'
  },
  divider: {
    borderColor: 'var(--color-bg-border-grey)'
  },
  itemTitleBox: {
    maxWidth: '310px'
  }
};

// NOTE: For demonstration, assuming a simple definition for AiDashboardSx keys used below
export const competitorsStyles = {
  listItem: {
    display: 'flex',
    justifyContent: 'space-between', // Pushes Brand/Rank to the left, Score to the right
    alignItems: 'center',
    paddingY: { xs: 1, md: 1.5 }, // Spacing above and below each row
    gap: { xs: '8px', md: '12px' },
    // Add a bottom border to mimic the dividers in the image
    borderBottom: '1px solid var(--color-bg-mid-grey)',
    '&:last-child': { borderBottom: 'none' }, // Remove border from the last item
    '&:first-of-type': { borderBottom: 'none' } // Remove border from the first item while keeping SSR safe
  },
  rankText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-text-placeholder)'
  },
  brandName: (index) => ({
    fontFamily: 'Inter',
    fontWeight: index == 0 ? 600 : 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: index == 0 ? 'var(--color-primary)' : 'var(--color-text-navy)',
    marginLeft:
      index == 0 ? { xs: '2px', md: '4px' } : { xs: '2px', md: '4px' },
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: { xs: '150px'}
  }),
  scoreText: (index) => ({
    fontWeight: index == 0 ? 600 : 500,
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'right',
    color: index == 0 ? 'var(--color-primary)' : 'var(--color-text-navy)'
  }),
  modalLogo: {
    // Assuming this is defined in your AiDashboardSx
    width: 24,
    height: 24
  },
  numText: (index) => ({
    fontFamily: 'Inter',
    fontWeight: index == 0 ? 600 : 400,
    fontSize: { xs: '13px', md: '14px' },
    lineHeight: 'var(--line-height-20)',
    color: index == 0 ? 'var(--color-primary)' : 'var(--color-text-placeholder)',
    marginRight:
      index == 0 ? { xs: '3px', md: '7px' } : { xs: '1px', md: '4.7px' },
    flexShrink: 0
  })
};

export const AIAnalysisNMetricsStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  },
  breadcrumbs: {
    inactiveText: {
      fontFamily: 'Inter',
      fontSize: 'var(--font-size-14)',
      fontWeight: 400,
      lineHeight: 'var(--line-height-20)',
      textAlign: 'left',
      color: 'var(--color-text-tertiary)',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    activeText: {
      fontFamily: 'Inter',
      fontSize: 'var(--font-size-14)',
      fontWeight: 400,
      lineHeight: 'var(--line-height-20)',
      textAlign: 'left',
      color: 'var(--color-primary)',
      '&:hover': {
        cursor: 'pointer'
      }
    }
  },

  header: {
    tutorial: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    title: {
      fontFamily: 'Inter',
      fontSize: 'var(--font-size-16)',
      fontWeight: 700,
      lineHeight: 'var(--line-height-24)',
      color: 'var(--color-purple-deep-alt)',
      cursor: 'pointer'
    }
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    left: {
      flex: 2,
      title: {
        fontFamily: 'Inter',
        fontSize: 'var(--font-size-30)',
        fontWeight: 600,
        lineHeight: 'var(--line-height-38)',
        color: 'var(--color-primary)'
      },
      description: {
        fontFamily: 'Inter',
        fontSize: 'var(--font-size-14)',
        fontWeight: 400,
        lineHeight: 'var(--line-height-20)',
        color: 'var(--color-text-secondary)',
        marginTop: '12px'
      }
    },
    right: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '& > div': {
        width: '100%'
      }
    }
  },

  mainContent: {
    display: 'flex',
    flexDirection: 'row',
    gap: { xs: '12px', md: '16px' },
    metricsAnalysis: {
      flex: 1,
      card: {
        height: '100%'
        // maxHeight: { xs: 360, sm: 400, md: 420 }
      },
      chartContainer: {
        width: '100%',
        height: { xs: 220, sm: 260, md: 300 }
      },
      title: {
        fontFamily: 'Inter',
        fontSize: { xs: '15px', md: '16px' },
        fontWeight: 500,
        lineHeight: 'var(--line-height-24)',
        color: 'var(--color-text-mid)'
      },
      description: {
        fontFamily: 'Inter',
        fontSize: { xs: '13px', md: '14px' },
        fontWeight: 400,
        lineHeight: 'var(--line-height-20)',
        color: 'var(--color-text-secondary)'
      }
    },
    metricsOverview: {
      flex: 1,
      card: {
        height: '100%',
        // maxHeight: { xs: 360, sm: 400, md: 420 },
        overflow: 'hidden'
      },
      headerRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        mb: 1
      },
      headerTitle: {
        fontFamily: 'Inter',
        fontWeight: 600,
        fontSize: { xs: '15px', md: '16px' },
        lineHeight: 'var(--line-height-24)',
        color: 'var(--color-text-mid)'
      },
      introText: {
        fontFamily: 'Inter',
        fontWeight: 400,
        fontSize: { xs: '13px', md: '14px' },
        lineHeight: 'var(--line-height-20)',
        color: 'var(--color-text-secondary)',
        mb: 1.5
      },
      subHeading: {
        fontFamily: 'Inter',
        fontWeight: 400,
        fontSize: { xs: '13px', md: '14px' },
        lineHeight: 'var(--line-height-20)',
        color: 'var(--color-text-secondary)',
        mb: 1.5
      },
      bodyText: {
        fontFamily: 'Inter',
        fontWeight: 400,
        fontSize: { xs: '13px', md: '14px' },
        lineHeight: 'var(--line-height-20)',
        color: 'var(--color-text-secondary)'
      },
      readMoreBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px'
      }
    },
    metricsSources: {
      flex: 1,
      card: {
        height: '100%'
        // maxHeight: { xs: 360, sm: 400, md: 420 }
      },
      header: {
        container: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        },
        left: {
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        },
        right: {
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        },
        pageText: {
          fontFamily: 'Inter',
          fontWeight: 400,
          fontSize: { xs: '13px', md: '14px' },
          lineHeight: 'var(--line-height-20)',
          color: 'var(--color-primary)'
        },
        navIcons: {
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        },
        icon: {
          fontSize: { xs: 18, md: 20 },
          color: 'var(--color-primary)',
          cursor: 'pointer'
        }
      },
      title: {
        fontFamily: 'Inter',
        fontSize: { xs: '15px', md: '16px' },
        fontWeight: 500,
        lineHeight: 'var(--line-height-24)',
        color: 'var(--color-text-mid)'
      },
      item: {
        container: {
          marginTop: '24px'
        },
        row: {
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        },
        title: {
          fontFamily: 'Inter',
          fontSize: 'var(--font-size-14)',
          fontWeight: 600,
          lineHeight: 'var(--line-height-20)',
          color: 'var(--color-primary)'
        },
        description: {
          marginTop: '4px',
          fontFamily: 'Inter',
          fontSize: 'var(--font-size-14)',
          fontWeight: 500,
          color: 'var(--color-text-navy)'
        }
      }
    },
    loaderBox: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },

    '@media (max-width: 768px)': {
      flexDirection: 'column'
    }
  },
  markDownParagraphSx: {
    marginBottom: '12px',
    fontWeight: 400,
    lineHeight: '26px'
  },
  markDownLinkSx: {
    color: 'var(--color-primary)', // Google blue
    textDecoration: 'none',
    fontWeight: 500,
    lineHeight: '26px',
    fontSize: '1rem'
  }
};

export const TopicVisibilitySx = {
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px'
  },
  filterBox: {
    marginTop: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  filterIconSx: {
    color: 'var(--color-primary)'
  },
  filterIconBoxSx: {
    width: 40,
    height: 40,
    gap: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid var(--color-text-muted-purple)',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  searchBarBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  headContainer: {
    padding: '24px'
  },
  topicSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-purple-strong)'
  },
  avgTopicSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: '#414651',
    width: '40px',
    textAlign: 'right'
  },
  avgTopicBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    width: '100%'
  },
  compareBoxSx: {
    width: '75px',
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0
  },
  lastAssessedSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  tableHeadSx: {
    padding: '16px 24px 16px 24px !important'
  },
  topPromptFilterBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  deletedChipSx: {
    backgroundColor: '#FFEBEE',
    color: 'var(--color-error-darker)',
    padding: '2px 8px',
    borderRadius: '16px',
    fontSize: '0.75rem',
    fontWeight: 500
  }
};

export const AiModelAnalysisDashboardSx = {
  topicAnalysisMetricsSx: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: { xs: '22px', sm: '26px', md: '30px' },
    lineHeight: { xs: '28px', sm: '32px', md: '38px' }
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    maxWidth: { xs: '100%', md: '430px' }
  },
  titleBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '8px', md: '12px' },
    flex: 1,
    minWidth: 0
  },
  mainTitleBox: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'flex-start', md: 'flex-start' },
    justifyContent: 'space-between',
    gap: { xs: '16px', md: '24px' }
  },
  mainBoxSx: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: { xs: '12px', md: '16px' }
  },
  topicVisibilitySx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: { xs: '14px', md: '16px' },
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-mid)'
  },
  topicVisibilityBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: '6px', md: '8px' },
    marginBottom: { xs: '8px', md: '12px' }
  },
  scoreDesc: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)',
    marginTop: { xs: '8px', md: '12px' },
    textAlign: 'left'
  },
  topPromptsSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-mid)'
  },
  promptSx: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-navy)'
  },
  promptBoxSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: '16px',
    paddingBottom: '16px',
    gap: '16px'
  },
  topPromptHeaderSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  paginationTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    color: 'var(--color-primary)'
  },
  card: (isNoSpace = null) => ({
    gap: '16px',
    backgroundColor: 'var(--color-white)',
    boxShadow: '0px 0px 12px 2px rgba(0,0,0,0.06)',
    padding: isNoSpace ? '0px' : { xs: '16px', md: '24px' },
    borderRadius: '8px',
    height: 'auto',
    width: '100%'
  }),
  questionBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  promptPerSx: (theme) => ({
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: theme?.palette?.primary?.main,
    minWidth: '50px'
  })
};

// ---------- Styles ----------
export const competitorTableSx = {
  container: {
    width: '100%',
    marginTop: { xs: '8px', md: '12px' },
    overflowX: 'auto',
    minHeight: '100px'
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: { xs: 1, md: 1.5 },
    gap: { xs: '8px', md: '12px' }
  },
  headerText: {
    fontWeight: 500,
    fontFamily: 'Inter',
    fontSize: { xs: '11px', md: '12px' },
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-text-placeholder)'
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    py: { xs: '8px', md: '10px' },
    gap: { xs: '8px', md: '12px' }
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 0.8, md: 1.2 },
    maxWidth: { xs: '100%', md: '85%' },
    minWidth: 0,
    flex: 1
  },
  urlText: {
    fontWeight: 500,
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-navy)',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: { xs: '100%', md: '90%' }
  },
  percentText: {
    fontWeight: 500,
    fontFamily: 'Inter',
    fontSize: { xs: '13px', md: '14px' },
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-navy)',
    whiteSpace: 'nowrap'
  },
  divider: {
    borderColor: 'rgba(0,0,0,0.1)',
    my: { xs: 0.25, md: 0.5 },
    marginBottom: { xs: '8px', md: '12px' }
  }
};

